export function phoneNumberDisplayFormat(phoneNumberString: string) {
  const cleaned = phoneNumberString.replace(/\D/g, '');
  const res = `${cleaned.slice(0, 3)}${cleaned.length > 3 ? '-' : ''}${cleaned.slice(3, 6)}${
    cleaned.length > 6 ? '-' : ''
  }${cleaned.slice(6)}`;
  return res;
}
